var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-upload",
        {
          attrs: {
            multiple: true,
            customRequest: _vm.handleFileUpload,
            "file-list": _vm.fileList,
            "before-upload": _vm.beforeFileUpload,
            showUploadList: false,
            accept: _vm.accept
          }
        },
        [
          _c(
            "a-button",
            [
              _c("a-icon", { attrs: { type: "upload" } }),
              _vm._v("选择文件\n    ")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("imgView", {
        ref: "imgView",
        attrs: { src: _vm.viewSrc },
        on: {
          "update:src": function($event) {
            _vm.viewSrc = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a76abb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a76abb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/invoiceUpload/index.vue
// module id = yuB7
// module chunks = 1